// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { TicketState } from "@/types/ticket";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Ticket } from "@/models/ticket";

const state: TicketState = {
  single: new Ticket(),
  pagination: new Pagination(),
};

export const ticket: Module<TicketState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
